import { Action, State, StateContext } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { FindCareerInterestsGQL, CareerInterest, CareerHouse, CareerSurveyResult, SchemaIntrospectionGQL } from 'generated/graphql';
import { Observable, tap } from 'rxjs';
import { makeBaseEntitiesState, makeDefaultEntitiesState } from '@common/state/entities.state';

export { CareerHouse, CareerSurveyResult } from 'generated/graphql';

export class CareerInterestsFindManyAction {
  static readonly type = '[Career Interests] Find Many';

  constructor() {}
}

export class CareerInterestsSchemaIntrospectionAction {
  static readonly type = '[Career Interests] Schema Introspection';
}

const CareerInterestsBaseEntitiesState = makeBaseEntitiesState<CareerInterest>('careerInterests');

@State({
  name: 'careerInterests',
  defaults: makeDefaultEntitiesState(),
})
@Injectable()
export class CareerInterestsEntitiesState extends CareerInterestsBaseEntitiesState {
  // schemaIntrospectionGQL = inject(SchemaIntrospectionGQL);
  findCareerInterestsGQL = inject(FindCareerInterestsGQL);

  @Action(CareerInterestsFindManyAction)
  find(ctx: StateContext<any>, action: CareerInterestsFindManyAction): Observable<any> {
    return this.findCareerInterestsGQL.fetch({}, { fetchPolicy: 'no-cache' }).pipe(
      tap((result) => {
        this.patchEntities(ctx, result.data.findCareerInterests as CareerInterest[]);
      })
    );
  }

  // @Action(CareerInterestsSchemaIntrospectionAction)
  // schemaIntrospection(ctx: StateContext<any>, action: CareerInterestsSchemaIntrospectionAction) {
  //   return this.schemaIntrospectionGQL.fetch({ entityName: 'CareerInterest' }).pipe(
  //     tap((result) => {
  //       this.patchSchema(ctx, result.data.__type);
  //     })
  //   );
  // }
}
